import React from 'react';
import { ReactComponent as IntroductionDevices } from '../../assets/introductionDevices.svg';
import { ReactComponent as ScreenIcon } from '../../assets/screenIcons.svg';
import { ReactComponent as ControllerIcon } from '../../assets/controllerIcon.svg';
import { ReactComponent as FriendsIcon } from '../../assets/friendsIcon.svg';
import { ReactComponent as StadiaIcon } from '../../assets/stadiaIcon.svg';
import { ReactComponent as LunaIcon } from '../../assets/lunaIcon.svg';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';
import { ReactComponent as ClockIcon } from '../../assets/clockIcon.svg';
import { ReactComponent as DeviceLogo } from '../../assets/deviceLogo.svg';
import { ReactComponent as WifiLogo } from '../../assets/wifiLogo.svg';
import { ReactComponent as ChainsLogo } from '../../assets/chainsLogo.svg';
import { ReactComponent as StarterPackChainsSmallIcon } from '../../assets/starterPackChainsSmallIcon.svg';
import { ReactComponent as StarterPackControllerSmallIcon } from '../../assets/starterPackControllerSmallIcon.svg';
import { ReactComponent as StarterPackControllerBigIcon } from '../../assets/starterPackControllerBigIcon.svg';
import { ReactComponent as StarterPackDeviceSmallIcon } from '../../assets/starterPackDeviceSmallIcon.svg';
import { ReactComponent as StarterPackDeviceBigIcon } from '../../assets/starterPackDeviceBigIcon.svg';
import { ReactComponent as StarterPackWifiSmallIcon } from '../../assets/starterPackWifiSmallIcon.svg';
import { ReactComponent as StarterPackWifiBigIcon } from '../../assets/starterPackWifiBigIcon.svg';

/*** Return the right svg component with the passed key
 *  * @param svgKey : Key that determines what svg to return
 */
export function getSvgComponent(svgKey : string) {
  switch (svgKey) {
    case 'introductionDevices':
      return <IntroductionDevices/>;
    case 'screenIcons':
      return <ScreenIcon/>;
    case 'controllerIcon' :
      return <ControllerIcon/>;
    case 'friendsIcon' :
      return <FriendsIcon/>;
    case 'stadia' :
      return <StadiaIcon/>;
    case 'luna' :
      return <LunaIcon/>;
    case 'clockIcon' :
      return <ClockIcon/>;
    case 'ubisoft' :
      return <UbisoftPlusLogo/>;
    case 'deviceIcon' :
      return <DeviceLogo/>;
    case 'wifiIcon' :
      return <WifiLogo/>;
    case 'chainsIcon' :
      return <ChainsLogo/>;
    case 'starterPackChainsSmallIcon' :
      return <StarterPackChainsSmallIcon/>;
    case 'starterPackControllerSmallIcon' :
      return <StarterPackControllerSmallIcon/>;
    case 'starterPackControllerBigIcon' :
      return <StarterPackControllerBigIcon/>;
    case 'starterPackDeviceSmallIcon' :
      return <StarterPackDeviceSmallIcon/>;
    case 'starterPackDeviceBigIcon' :
      return <StarterPackDeviceBigIcon/>;
    case 'starterPackWifiSmallIcon' :
      return <StarterPackWifiSmallIcon/>;
    case 'starterPackWifiBigIcon' :
      return <StarterPackWifiBigIcon/>;
    default:
      break;
  }
}
